import { render, staticRenderFns } from "./EditCoverage.vue?vue&type=template&id=4bc57e38&scoped=true&"
import script from "./EditCoverage.vue?vue&type=script&lang=js&"
export * from "./EditCoverage.vue?vue&type=script&lang=js&"
import style0 from "./EditCoverage.vue?vue&type=style&index=0&id=4bc57e38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc57e38",
  null
  
)

export default component.exports